import React, { useState } from 'react';
import QuizzWidgetAnswer from "./QuizzWidgetAnswer";

const QuizzWidgetQuestion = ({ id, question, answers, onOptionSelect, selectedOptionId, answersCount }) => {

    return (
        <div className="flex flex-col items-center">
            <h2 className="flex items-end text-32 md:text-28 xs:text-20 mt-32 text-primary font-bold leading-sm pb-12 text-center max-w-970 ">{question}</h2>
            <div className="flex w-full mt-10 items-center justify-center min-h-40vh sm:min-h-47vh">
                <div className={`w-full flex flex-wrap justify-center sm:justify-start${answers.length === 5 ? " max-options" : ""}${!answers[0].image ? " sm:max-w-554 w-full-16 -mx-8 sm:mx-0" : " xs:max-w-340 w-full-40 -mx-20 md:w-full-28 md:-mx-14 sm:w-full-20 sm:-mx-10"} `}>
                    {answers.map(answer =>
                        <QuizzWidgetAnswer 
                            key={answer.id} 
                            {...answer} 
                            answersCount={answersCount}
                            onOptionSelect={onOptionSelect}
                            checked={selectedOptionId === answer.id} 
                            selectedOptionId={selectedOptionId}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default QuizzWidgetQuestion;

